var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"centerLeft1"}},[_vm._m(0),_c('rightBottomChart')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('span',{staticClass:"text"},[_vm._v("数字果园面积占比")])])
}]

export { render, staticRenderFns }